export default __webpack_public_path__ + "static/media/oliver-peoples-5.6acacc3e.png";